import React from 'react';

import { FormSearchGeoRegionField } from 'components/Form';

const FilterSearchGeoLocalityField = (props) => {
  const { source, children, ...rest } = props;

  return (
    <FormSearchGeoRegionField
      name={source}
      submitOnChange={true}
      forced={true}
      disableClearable={false}
      {...rest}
    />
  );
};

export default React.memo(FilterSearchGeoLocalityField);
